import {
  AfterViewInit,
  Directive,
  ElementRef,
  effect,
  inject,
  input,
  Renderer2,
  booleanAttribute,
} from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[matBadgeIcon]',
  standalone: true,
})
export class MatBadgeIconDirective implements AfterViewInit {
  readonly matBadgeIcon = input<string>('');
  readonly hideMatBadgeIcon = input(false, { transform: booleanAttribute });

  private readonly elementRef = inject(ElementRef<HTMLElement>);
  private readonly renderer = inject(Renderer2);

  private badgeElement: HTMLElement | null = null;

  constructor() {
    effect(() => {
      const iconName = this.matBadgeIcon();
      const isHidden = this.hideMatBadgeIcon();
      if (isHidden) {
        this.removeIcon();
        return;
      }

      if (this.badgeElement && iconName && !isHidden) {
        this.renderIcon(iconName);
      }
    });
  }

  ngAfterViewInit(): void {
    this.badgeElement =
      this.elementRef.nativeElement.querySelector('.mat-badge-content');

    const isHidden = this.hideMatBadgeIcon();
    const iconName = this.matBadgeIcon();

    if (isHidden) {
      this.removeIcon();
      return;
    }

    if (this.badgeElement && iconName && !isHidden) {
      this.renderIcon(iconName);
    }
  }

  private renderIcon(iconName: string): void {
    if (!this.badgeElement) return;

    this.renderer.setStyle(this.badgeElement, 'display', 'flex');
    this.renderer.setStyle(this.badgeElement, 'align-items', 'center');
    this.renderer.setStyle(this.badgeElement, 'justify-content', 'center');
    this.renderer.setStyle(this.badgeElement, 'border-radius', '50%');
    this.renderer.setStyle(this.badgeElement, 'width', '18px');
    this.renderer.setStyle(this.badgeElement, 'height', '18px');
    this.badgeElement.replaceChildren();

    const icon = this.renderer.createElement('span');
    this.renderer.addClass(icon, 'material-symbols-outlined');
    this.renderer.setStyle(icon, 'font-size', '16px');
    this.renderer.setStyle(icon, 'line-height', '12px');

    icon.textContent = iconName;

    this.renderer.appendChild(this.badgeElement, icon);
  }

  private removeIcon() {
    if (!this.badgeElement) return;
    this.renderer.setStyle(this.badgeElement, 'display', 'none');
  }
}
